import { FC, useState } from "react";
import { Form, FormItemProps } from "antd";
import PhoneInput from "react-phone-input-2";
import { useSelector, useIntl } from "hooks";

const phoneProps = {
  inputStyle: { width: "100%" },
  enableSearch: true,
};

interface PhoneInputProps {
  value?: string | null;
  onChange?: (v: any) => void;
}

const CustomPhoneInput: FC<PhoneInputProps> = ({ value, onChange }) => {
  const { countryCode, language } = useSelector((state) => {
    return {
      countryCode: state.appState.userGeo?.country_code?.toLowerCase(),
      language: state.appState.language,
    };
  });
  const [defaultCountryCode, setCountryCode] = useState(countryCode);

  const onInputChange = (
    newValue: string,
    countryData: { countryCode: string }
  ) => {
    if (onChange) {
      onChange(newValue);
    }

    if (countryData.countryCode !== defaultCountryCode) {
      setCountryCode(countryData.countryCode);
    }
  };

  const country = !value ? { country: defaultCountryCode } : {};
  const preferredCountries =
    language === "zh"
      ? ["cn", "tw", "sg", "us", "au"]
      : ["au", "us", "sg", "cn", "tw"];

  return (
    <PhoneInput
      {...country}
      {...phoneProps}
      key={language}
      value={value}
      onChange={onInputChange}
      enableSearch
      preferredCountries={preferredCountries}
      preserveOrder={["preferredCountries"]}
      masks={{ au: "(.) ....-...." }}
    />
  );
};

export default ({
  required,
  rules = [],
  label,
  ...props
}: FormItemProps & { label: string }) => {
  const intl = useIntl();

  return (
    <Form.Item
      {...props}
      label={intl.formatMessage({ id: label, defaultMessage: "" })}
      getValueProps={(value) => value && { value }}
      rules={[
        {
          required,
          message: intl.formatMessage({ id: "validation.required" }),
        },
        ...rules,
      ]}
    >
      <CustomPhoneInput />
    </Form.Item>
  );
};
